
<template>
  <div class="border-div"
    style="display:flex;align-items:center;border-bottom:1px solid #E8E8E8;border-right: 1px solid #E8E8E8;">
    <div v-if="treeData.spec_value_name!=''" style="display:inline-block;min-width:150px;text-align:center">
      {{treeData.spec_value_name}}</div>
    <template>
      <div v-if="treeData.children &&  treeData.children!='-10'" style="border-left: 1px solid #E8E8E8;">
        <treeComp v-for="(item, index) in treeData.children" :treeData="item" :key="index"></treeComp>
      </div>
      <div v-else style="border-left:1px solid #E8E8E8">
        <el-input type="text" placeholder="请输入数字" v-model="treeData.price" @input="ass" maxlength="8"
          style="display:inline-block;width:130px;margin: 10px;box-sizing: border-box;"></el-input>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'treeComp',
  props: {
    treeData: {
      default: function () {
        return []
      }
    }
  },
  mounted() {
    console.log('this.treeData', this.treeData);
  },
  methods: {
    ass(e) {
      console.log(e);
      let arr = []
      let arr2 = []
      if (e.length > 6) e = e.slice(0, 8)
      // console.log(this.treeData.price);
      for (let index = 0; index < e.length; index++) {
        console.log(e[index]);
        // arr.push(Number(e[index]))
        if (e[index] == '.') {
          arr.push(e[index])
        }
        arr.push(Number(e[index]))
      }
      for (let index = 0; index < arr.length; index++) {
        console.log(arr[index])
        if (arr[index] == arr[index]) {
          arr2.push(arr[index])
        }

      }
      console.log(arr);

      console.log(arr2.join(''));
      this.treeData.price = arr2.join('')
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield !important;
}

.border-div:last-child {
  border-bottom: none;
}

.el-form-item__content {
  overflow: hidden;
}
</style>